module.exports = __webpack_public_path__ + "static/media/offline.c7d84e0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/offline.svg
// module id = 860
// module chunks = 0